<div class="main-wrapper">
  <div class="container">
    <div class="heading text-center">How It Works?</div>
    <div class="divider"></div>
    <div class="cards">
      <div class="card" *ngFor="let item of stepsArr">
        <div class="number">
          {{item.number}}
        </div>
        <div class="desc">
          {{item.desc}}
        </div>
      </div>
    </div>
    <div class="extra-note">
      <span>
        Memorial fundraising on Ketto has been created by and for real people.
        Once you've set up your memorial fundraiser campaign, you can receive funds from contributors all around the world.
      </span>
      <span>
        There is no other easier way to raise money for a memorial fund than Ketto's online fundraising platform. Allow others to contribute today by providing them with a simplified way to donate.
      </span>
    </div>
  </div>
</div>
